import { render, staticRenderFns } from "./formbuilderTemplatePreview.vue?vue&type=template&id=0d80e218&scoped=true"
import script from "./formbuilderTemplatePreview.vue?vue&type=script&lang=js"
export * from "./formbuilderTemplatePreview.vue?vue&type=script&lang=js"
import style0 from "./formbuilderTemplatePreview.vue?vue&type=style&index=0&id=0d80e218&prod&lang=scss&scoped=true"
import style1 from "./formbuilderTemplatePreview.vue?vue&type=style&index=1&id=0d80e218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d80e218",
  null
  
)

export default component.exports